<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb :lastItemName="experience.name" />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تیکت
        </b-button>
      </b-col>
    </b-row>
    <div v-if="experienceDates">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead class="d-flex">
          <b-tr>
            <b-th>id</b-th>
            <b-th>ترتیب نمایش</b-th>
            <b-th>عنوان</b-th>
            <!--            <b-th>ایام تیکت</b-th>-->
            <b-th>ظرفیت</b-th>
            <b-th>نوع تیکت</b-th>
            <b-th>هزینه</b-th>
            <b-th>کمسیون سایت</b-th>
            <b-th>تاریخ ایجاد</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <draggable v-model="experienceDates" @end="updateOrder" style="cursor: pointer">

          <b-tr v-for="item in experienceDates" :key="item.id">
            <b-td>{{ item.id }}</b-td>
            <b-td>{{item.order_number}}</b-td>
            <b-td>{{ item.name }}</b-td>
            <!--            <b-td>
                          <b-badge variant="success" class="badge-glow" v-for="(day,i) in item.recurring_period" style="margin: 4px">
                            <span v-if="day==='Saturday'">
                              شنبه
                            </span>
                            <span v-if="day==='Sunday'">
                              یکشنبه
                            </span>
                            <span v-if="day==='Monday'">
                              دوشنبه
                            </span>
                            <span v-if="day==='Tuesday'">
                              سه شنبه
                            </span>
                            <span v-if="day==='Wednesday'">
                              چهارشنبه
                            </span>
                            <span v-if="day==='Thursday'">
                              پنج شنبه
                            </span>
                            <span v-if="day==='Friday'">
                              جمعه
                            </span>
                          </b-badge>
                        </b-td>-->
            <b-td>{{item.max_people}} نفر</b-td>
            <b-td>
              <span v-if="item.price_type==='pricePerPerson'">
                به ازای هر فرد
              </span>
              <span v-else>
                به ازای هر وسیله نقلیه
              </span>

            </b-td>
            <b-td>{{ item.prices.normal_dayes }}</b-td>
            <b-td>
              <span v-if="item.commission_site">
                {{item.commission_site}} به ازای هر فرد
              </span>
              <span v-if="item.commission_host">
                   {{item.commission_host}}  میزبان
              </span>
            </b-td>

            <b-td>
              {{
                new Date(item.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  item.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ item.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
                <!--                <b-button
                                  @click="showConfirmModal(item)"
                                  variant="flat-danger"
                                  class="font-weight-bolder"
                                >
                                  <feather-icon icon="Trash2Icon" size="20" />
                                </b-button>-->
                <b-button
                    @click="showFormModal(item)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </draggable>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="80%"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تیکت" : "ایجاد تیکت" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="row">
        <b-form-group class="col-md-6">
          <label for="name" class="text-capitalize">
            عنوان تیکت : <span class="text-danger">*</span></label
          >
          <b-form-input
              @input="removeErrors('name')"
              id="name"
              v-model="ticketInput.name"
              type="text"
          />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            نوع اجرا :<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['گروهی', 'نفری']"
              v-model="ticketInput.execution_type"
          />
        </b-form-group>

        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            جنسیت :<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['آقا', 'هردو', 'خانم']"
              v-model="ticketInput.gender"
          />
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            نوع تیکت :<span class="text-danger">*</span>
          </label>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['vip', 'ارگانی', 'معمولی']"
              v-model="ticketInput.ticket_type"
          />
        </b-form-group>

        <b-col cols="12" class="mb-2">
          <!--          {{ticketInput}}-->
          <b-form-group>
            <b-form-radio
                v-model="ticketInput.price_type"
                name="some-radios3"
                value="pricePerPerson"
            >قیمت به ازای هر فرد</b-form-radio
            >
            <b-form-radio
                v-model="ticketInput.price_type"
                name="some-radios3"
                value="pricePerCar"
            >قیمت به ازای هر وسیله </b-form-radio
            >
          </b-form-group>
        </b-col>


        <b-form-group class="mt-1 col-md-12" v-if="ticketInput.price_type !== 'pricePerCar'">
          <label for="name" class="text-capitalize">  حداکثر ظرفیت نفرات : </label>
          <b-form-input v-model="ticketInput.max_people" type="number" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12"  v-if="ticketInput.price_type !== 'pricePerPerson'">
          <label for="name" class="text-capitalize">  حداکثر تعداد وسیله   : </label>
          <b-form-input  v-model="ticketInput.max_people" type="number" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-if="ticketInput.price_type !== 'pricePerPerson'">
          <label for="name" class="text-capitalize">  حداکثر ظرفیت نفرات در وسیله  : </label>
          <b-form-input v-model="ticketInput.max_capacity_people" type="number" />
        </b-form-group>


        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">
            شروع راس ساعت : <span class="text-danger">*</span></label
          >
          <!--          <b-form-input
                      v-model="ticketInput.start_time"
                      locale="fa"
                      :id="`type-${1}`"
                      type="time"
                    ></b-form-input>-->
          <date-picker v-model="ticketInput.start_time" type="time" />
        </b-form-group>
        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">
            پایان راس ساعت :<span class="text-danger">*</span>
          </label>
          <date-picker v-model="ticketInput.end_time" type="time" />
          <!--          <b-form-input
                      v-model="ticketInput.end_time"
                      locale="fa"
                      :id="`type-${2}`"
                      type="time"
                    ></b-form-input>-->
        </b-form-group>


        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">
            چه زمانی قبل از شروع مهمان می تواند رزرو کند؟  <span class="text-danger">*</span></label
          >
          <date-picker v-model="ticketInput.reservation_cutoff" type="time" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">
            توضیحات در مورد تیکت :
          </label>
          <!--          <date-picker v-model="ticketInput.time_close" type="time" />-->
          <b-form-input v-model="ticketInput.time_close" type="text" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  مدت زمان اجرای هر تیکت  مثلا ( 10 دقیقه یا 2 ساعت واحد زمان ذکر گردد ) : </label>
          <b-form-input v-model="ticketInput.duration" type="text" />
        </b-form-group>


        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
              v-model="ticketInput.is_recurring_period"
              :aria-describedby="ariaDescribedby"
              value="1"
              @input="removeErrors('status')"
          >دوره تکرار شونده</b-form-checkbox
          >
        </b-form-group>
        <!--        <b-form-group v-if="!ticketInput.is_recurring_period" class="col-md-6">
                  <label for="name" class="text-capitalize"> روز شروع : </label>
                  <b-form-input class="my-custom-editable-input1" type="text" />
                  <date-picker
                    auto-submit
                    clearable
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    v-model="ticketInput.start_date"
                    custom-input=".my-custom-editable-input1"
                  />
                </b-form-group>
                <b-form-group v-if="!ticketInput.is_recurring_period" class="col-md-6">
                  <label for="name" class="text-capitalize"> روز پایان : </label>
                  <b-form-input class="my-custom-editable-input2" type="text" />
                  <date-picker
                    auto-submit
                    clearable
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    v-model="ticketInput.return_date"
                    custom-input=".my-custom-editable-input2"
                  />
                </b-form-group>-->

        <!--        <b-form-group
                    label="روزهای در دسترس"
                    class="col-md-12 font-sm"
                    v-slot="{ ariaDescribedby }"
                    v-if="ticketInput.is_recurring_period"
                >
                  <b-form-checkbox-group
                      v-model="ticketInput.recurring_period"
                      :options="dayOptions"
                      :aria-describedby="ariaDescribedby"
                      name="flavour-1a"
                      class="font-sm"
                  ></b-form-checkbox-group>
                </b-form-group>-->

        <b-col class="mt-2" md="12" cols="12" v-if="ticketInput.is_recurring_period">
          <date-picker
              auto-submit
              inline
              multiple
              clearable
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jDD"
              v-model="selectedDates"
              @input="onDateSelect"
              custom-input="#my-custom-editable-input"
          />
        </b-col>

        <b-form-group class="col-md-2" v-for="(entry, index) in dateCapacities" :key="index">
          <label :for="'capacity-' + index" style="background: yellow;
    padding: 3px;
    font-weight: 600;border-radius: 4px">
            ظرفیت
           <span style="background: #000;color: #fff;
    ">
              {{
               new Intl.DateTimeFormat('fa-IR', {
                 month: 'long',
                 day: 'numeric',
               }).format(new Date(entry.date))
             }}
           </span>
          </label>
          <b-form-input
              v-model="entry.capacity"
              type="number"
              :id="'capacity-' + index"
          />
        </b-form-group>
        <label for="name" class="text-capitalize col-md-12 mt-2">
          هزینه ها :<span class="text-danger">*</span>
        </label>
        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> ایام عادی : </label>
          <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.normal_dayes" type="text" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> ایام آخر هفته : </label>
          <b-form-input :formatter="formatnumber"  v-model="ticketInput.prices.weekend_days" type="text" />
        </b-form-group>

        <!--        <b-form-group class="mt-1 col-md-6">
                  <label for="name" class="text-capitalize"> ایام پیک : </label>
                  <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.peack_days" type="text" />
                </b-form-group>-->
        <b-form-group class="col-md-6">
          <b-form-checkbox
              :label="ticketInput.prices.pricePerBaby.name"
              v-model="ticketInput.prices.pricePerBaby.hasPrice"
          >
            هزینه به ازای هر نوزاد
          </b-form-checkbox>
          <b-form-input
              lazy
              :formatter="formatnumber"
              :disabled="!ticketInput.prices.pricePerBaby.hasPrice"
              v-model="ticketInput.prices.pricePerBaby.price"
          ></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-6">
          <b-form-checkbox
              :label="ticketInput.prices.pricePerAnimal.name"
              v-model="ticketInput.prices.pricePerAnimal.hasPrice"
          >
            هزینه حیوانات</b-form-checkbox
          >
          <b-form-input
              lazy
              :formatter="formatnumber"
              :disabled="!ticketInput.prices.pricePerAnimal.hasPrice"
              v-model="ticketInput.prices.pricePerAnimal.price"
          ></b-form-input>
        </b-form-group>
        <b-col md="12" class="mt-2"></b-col>
        <b-col cols="6" md="6"> تخفیف به تعداد نفرات </b-col>
        <b-col cols="6" md="6" class="d-flex justify-content-end">
          <b-form-group label-for="discount" class="col-md-6">
            <!-- @change="value2 = $events" -->
            <b-form-spinbutton
                name="discount"
                id="sb-input"
                v-model="discounts"
                size="sm"
                min="0"
                max="10"
                @input="removeDiscountBtnIsClicked = false,clickOnDiscountSpinBtn=true"
            ></b-form-spinbutton>
          </b-form-group>
        </b-col>

        <b-col
            md="12"
            v-for="(item, index) in ticketInput.prices_off"
            :key="'off_' + index"
        >
          <b-row>
            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">از : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.from" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تا : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.to" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تخفیف : </label>
              <b-form-input v-model.number="item.discount" type="number" />
            </b-form-group>
            <b-form-group class="mt-1 col-4 col-sm-2">
              <label for="name" class="text-capitalize">به صورت : </label>
              <b-form-input disabled type="text" value="درصدی" />
            </b-form-group>
            <b-button
                @click="removeDiscount(index)"
                variant="flat-danger"
                class="font-weight-bolder col-1 col-sm-1"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
          </b-row>
        </b-col>

        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            کد تخفیف برای کدام گروه اعمال گردد در صورتی که تخفیف گروهی اعمال گردد:<span class="text-danger">*</span>
          </label>
          <div>
            <div>discount_host : از طرف میزبان</div>
            <div>discount_site : از طرف سایت</div>
            <div>discount_both : از طرف هر دو</div>
          </div>
          <v-select
              id="residence_area"
              :components="{ OpenIndicator }"
              class="bg-white"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="['discount_host', 'discount_site', 'discount_both']"
              v-model="ticketInput.discount"
          />
        </b-form-group>
        <b-col md="12" class="mt-2"> </b-col>
        <b-col md="12" class="mt-2"></b-col>
        <b-col cols="6" md="6"> خدمات ویژه </b-col>
        <b-col cols="6" md="6" class="d-flex justify-content-end">
          <b-form-group label-for="discount" class="col-md-6">
            <!-- @change="value2 = $events" -->
            <b-form-spinbutton
                name="discount"
                id="sb-input"
                v-model="services"
                size="sm"
                min="0"
                max="10"
                @input="removeServicesBtnIsClicked = false,clickOnServiceSpinBtn=true"
            ></b-form-spinbutton>
          </b-form-group>
        </b-col>

        <b-col
            md="12"
            v-for="(item, index) in ticketInput.special_services"
            :key="'service_' + index"
        >
          <b-row>
            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">عنوان : </label>
              <b-form-input v-model="item.name" type="text" />
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">هزینه : </label>
              <b-form-input v-model.number="item.price" type="number" />
            </b-form-group>

            <b-form-group
                class="col-6 mt-1 col-sm-3"
                label="شیوه ارائه"
                label-for="min-night-input"
            >
              <b-form-select
                  v-model="item.method"
                  :options="methodss"
                  value-field="value"
                  text-field="text"
              ></b-form-select>
            </b-form-group>
            <b-form-group class="mt-1 col-4 col-sm-2">
              <b-form-checkbox
                  v-model="item.perPerson"
                  :id="`perperson_${index}`"
                  class="font-sm"
              ><small> به ازای هر نفر</small>
              </b-form-checkbox>
            </b-form-group>
            <b-button
                @click="removeService(index)"
                variant="flat-danger"
                class="font-weight-bolder col-1 col-sm-1"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
          </b-row>
        </b-col>


        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  کمیسیون دریافتی سایت به ازای هر فرد : </label>
          <b-form-input  v-model="ticketInput.commission_site" type="text" />
          <div v-if="ticketInput.commission_site>0">{{numberFormat(ticketInput.commission_site)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  کمیسیون میزبان : </label>
          <b-form-input  v-model="ticketInput.commission_host" type="text" />
          <div v-if="ticketInput.commission_host>0">{{numberFormat(ticketInput.commission_host)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  کمیسیون میزبان به ازای دریافتی هر نوزاد یا زیر 92 سانت : </label>
          <b-form-input  v-model="ticketInput.commission_baby" type="text" />
          <div v-if="ticketInput.commission_baby>0">{{numberFormat(ticketInput.commission_baby)}} تومان</div>
        </b-form-group>
        <hr/>
        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
              v-model="ticketInput.is_agency"
              :aria-describedby="ariaDescribedby"
              value="1"
              @input="removeErrors('status')"
          >فعالسازی قیمت برای آژانس</b-form-checkbox
          >
        </b-form-group>
        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">  قیمت فروش برای آژانس : </label>
          <b-form-input  v-model="ticketInput.agency_price" type="text" />
          <div v-if="ticketInput.agency_price>0">{{numberFormat(ticketInput.agency_price)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-60">
          <label for="name" class="text-capitalize">  کمیسیون دریافتی میزبان از آژانس ها : </label>
          <b-form-input  v-model="ticketInput.commission_agency_host" type="text" />
          <div v-if="ticketInput.commission_agency_host>0">{{numberFormat(ticketInput.commission_agency_host)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت رزروی : </label>
          <b-form-checkbox
              v-model="ticketInput.booking_type"
              :aria-describedby="ariaDescribedby"
              value="instant"
              @input="removeErrors('booking_type')"
          >آنی (پیشفرض)</b-form-checkbox
          >
          <b-form-checkbox
              v-model="ticketInput.booking_type"
              :aria-describedby="ariaDescribedby"
              value="inquiry"
              @input="removeErrors('booking_type')"
          >استعلامی</b-form-checkbox
          >
          <ErrorMessage
              errorType="booking_type"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
              v-model="ticketInput.status"
              :aria-describedby="ariaDescribedby"
              value="active"
              @input="removeErrors('status')"
          >فعال</b-form-checkbox
          >
          <b-form-checkbox
              v-model="ticketInput.status"
              :aria-describedby="ariaDescribedby"
              value="inactive"
              @input="removeErrors('status')"
          >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
              errorType="status"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>

      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BTime,
  BInputGroup, BBadge,BFormRadio
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import draggable from 'vuedraggable';
export default {
  components: {
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BTime,
    datePicker: VuePersianDatetimePicker,
    BInputGroup, BFormRadio,
    draggable
  },
  data() {
    return {

      dayOptions: [
        { text: 'شنبه', value: 'Saturday' },
        { text: 'یکشنبه', value: 'Sunday' },
        { text: 'دوشنبه', value: 'Monday' },
        { text: 'سه شنبه', value: 'Tuesday' },
        { text: 'چهارشنبه', value: 'Wednesday' },
        { text: 'پنجشنبه', value: 'Thursday' },
        { text: 'جمعه', value: 'Friday' },
      ],
      optionsShow: [
        { value: null, text: "انتخاب نمایش در ص اصلی" },
        { value: "0", text: "عدم نمایش در صفحه اصلی" },
        { value: "1", text: "نمایش در صفحه اصلی" },
      ],
      experience: {},
      iconImageurl: "",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      experienceDates: [],
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "نمایش در صفحه",
          slug: "show_index_page",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      selectedDates: [],
      dateCapacities: [],
      ticketInput: {
        id: "",
        name: "",
        slug: "",
        description: "",
        status: "",
        booking_type: "",
        max_people: "",
        max_capacity_people: "",
        commission_site: "",
        commission_host: "",
        commission_baby: "",
        duration: "",
        reservation_cutoff: "",
        price_type: "",
        discount: "",
        data: "",
        order_number: "",

        image: null,
        icon: "",
        show_index_page: "",
        is_recurring_period: false,

        is_agency: false,
        agency_price: "",
        commission_agency_host: "",



        recurring_period: [],
        prices: {
          priceType: "pricePerKillometers",
          peack_days: null,
          normal_dayes: null,
          weekend_days: null,
          pricePerBaby: {
            name: "هزینه به ازای هر نوزاد",
            price: "",
            hasPrice: false,
          },
          pricePerAnimal: {
            name: "هزینه حیوانات",
            price: "",
            hasPrice: false,
          },
          start_date: null,
          end_date: null,
        },
        special_services: [],
        prices_off: [],
        execution_type: "",
        gender: "",
        ticket_type: "",
        start_date: null,
        return_date: null,
        time_close: null,
      },
      methodss: [
        { value: "daily", text: "روزانه" },
        { value: "oneTime", text: "یکبار" },
      ],
      editMode: false,
      formModal: false,
      submitLoading: false,
      discounts: 0,
      removeDiscountBtnIsClicked: false,
      services: 0,
      removeServicesBtnIsClicked: false,
      clickOnDiscountSpinBtn:false,
      clickOnServiceSpinBtn:false
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getTickets();
    this.getBuildings();
    this.getExperience();
    this.loadExistingData();
  },
  watch: {
    'ticketInput.data': {
      handler() {
        this.loadExistingData();
      },
      immediate: true
    },
    searchInput(value) {
      this.page = 1;
      this.getTickets();
    },
    perPage(value) {
      this.page = 1;
      this.getTickets();
    },
    page(value) {
      this.getTickets();
    },
    discounts(newVal, oldVal) {
      if (this.removeDiscountBtnIsClicked|| !this.clickOnDiscountSpinBtn) {
        this.clickOnDiscountSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.prices_off = [];
      } else if (newVal < oldVal) {
        this.ticketInput.prices_off.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.prices_off.push({ from: "", to: "", discount: 0 });
      }
    },
    services(newVal, oldVal) {
      if (this.removeServicesBtnIsClicked || !this.clickOnServiceSpinBtn) {
        this.clickOnServiceSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.special_services = [];
      } else if (newVal < oldVal) {
        this.ticketInput.special_services.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.special_services.push({
          name: "",
          price: "",
          method: 0,
          perPerson: false,
        });
      }
    },
  },
  methods: {
    onDateSelect() {
      // Update dateCapacities when dates are selected
      this.updateDateCapacities();
    },
    updateDateCapacities() {
      // Create or update entries in dateCapacities based on selectedDates
      this.selectedDates.forEach(date => {
        const existingEntry = this.dateCapacities.find(entry => entry.date === date);
        if (!existingEntry) {
          this.dateCapacities.push({ date, capacity: this.ticketInput.max_people }); // Default capacity
        }
      });
      // Remove entries that are no longer in selectedDates
      this.dateCapacities = this.dateCapacities.filter(entry =>
          this.selectedDates.includes(entry.date)
      );
    },
    loadExistingData() {
      if (this.ticketInput.data) {
        try {
          // بررسی اینکه آیا داده‌ها یک رشته JSON هستند یا یک آبجکت
          const parsedData = typeof this.ticketInput.data === 'string'
              ? JSON.parse(this.ticketInput.data)
              : this.ticketInput.data;

          // داده‌ها را به متغیرهای مناسب تنظیم کنید
          this.dateCapacities = parsedData;
          this.selectedDates = parsedData.map(entry => entry.date);
        } catch (error) {
          console.error("Error parsing existing data:", error);
        }
      }
    },


    async updateOrder() {
      try {
        const requestData = {
          method: "post",
          url: "/admin/experiences/update-order",
          data: { experienceDates: this.experienceDates },
        };
        await this.$http(requestData);
        console.log('Order updated successfully');

        await this.getTickets();
      } catch (error) {
        console.error('Error updating order:', error);
      }
    },
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.ticketInput.image = file;
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getTickets();
    },

    async getTickets() {
      const requestData = {
        method: "get",
        url: "/admin/experiences/experience_dates/experience/"+this.$route.params.id+'?paginate=true',
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      await this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.experienceDates = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(experienceDate) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف بلیط مطمئن هستید ؟  : ${experienceDate.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.experienceDates = await this.experienceDates.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == experienceDate.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== experienceDate.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/experiences/experience_dates/${experienceDate.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `بلیط: ${experienceDate.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.experienceDates.splice(residenceIndex, 0, experienceDate);
                  });
            }
          });
    },
    showFormModal(experienceDate) {
      this.clickOnDiscountSpinBtn=false
      this.clickOnServiceSpinBtn=false
      if (experienceDate) {
        (this.ticketInput = {
          id: experienceDate.id,
          name: experienceDate.name,
          status: experienceDate.status,
          booking_type: experienceDate.booking_type,
          is_recurring_period: experienceDate.is_recurring_period,
          recurring_period: experienceDate.recurring_period,
          prices: experienceDate.prices,
          prices_off: experienceDate.prices_off,
          special_services: experienceDate.special_services,
          execution_type: experienceDate.execution_type,
          gender: experienceDate.gender,
          data: experienceDate.data,
          reservation_cutoff: experienceDate.reservation_cutoff,
          max_people:experienceDate.max_people,
          max_capacity_people:experienceDate.max_capacity_people,
          commission_site:experienceDate.commission_site,
          commission_host:experienceDate.commission_host,
          commission_baby:experienceDate.commission_baby,

          is_agency:experienceDate.is_agency,
          agency_price:experienceDate.agency_price,
          commission_agency_host:experienceDate.commission_agency_host,

          discount:experienceDate.discount,
          duration:experienceDate.duration,
          ticket_type: experienceDate.ticket_type,
          price_type:experienceDate.price_type,
          start_time: experienceDate.start_time,
          end_time: experienceDate.end_time,
          time_close: experienceDate.time_close,
          start_date: experienceDate.start_date,
          return_date: experienceDate.return_date,
        }),
            (this.discounts = experienceDate.prices_off.length),
            (this.services = experienceDate.special_services.length),
            (this.editMode = true);
      } else {
        (this.discounts = 0),
            (this.services = 0),
            (this.ticketInput = {
              name: "",
              status: "",
              booking_type: "",
              is_recurring_period: false,
              recurring_period: [],
              prices: {
                start_time: "",
                end_time: "",
                priceType: "pricePerKillometers",
                peack_days: null,
                normal_dayes: null,
                weekend_days: null,
                pricePerBaby: {
                  name: "هزینه به ازای هر نوزاد",
                  price: "",
                  hasPrice: false,
                },
                pricePerAnimal: {
                  name: "هزینه حیوانات",
                  price: "",
                  hasPrice: false,
                },
                start_date: null,
                end_date: null,
              },
              prices_off: [],
              special_services: [],
              execution_type: "",
              max_people:"",
              commission_site:"",
              commission_host:"",
              commission_baby:"",

              is_agency:"",
              agency_price:"",
              commission_agency_host:"",


              discount:"",
              duration:"",
              gender: "",
              reservation_cutoff: "",
              data: "",
              time_close:null,
              start_time:null,
              start_date: null,
              ticket_type: "",
            }),
            (this.editMode = false);
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;

      let errorMessage = null;
      if (!this.ticketInput.name) {
        errorMessage = "لطفا نام بلیط را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.submitLoading = true;
      this.ticketInput.data = this.dateCapacities;

      const method = this.editMode ? "post" : "post";
      const url = this.editMode
          ? `/admin/experiences/experience_dates/update/${this.ticketInput.id}`
          : `/admin/experiences/experience_dates`;

      const requestData = {
        method,
        url,
        data: { ...this.ticketInput, experience_id: this.$route.params.id },
      };

      this.$http(requestData)
          .then((response) => {
            const message = this.editMode
                ? "بلیط با موفقیت ویرایش شد"
                : "بلیط با موفقیت اضافه شد";

            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });

            this.submitLoading = false;
            this.formModal = false;
            this.getTickets();
          })
          .catch((err) => {

            let message = this.editMode
                ? "خطا در ویرایش بلیط"
                : "خطا در ایجاد بلیط";

            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            ) {
              message = err.response.data.response.message;
            }

            // اگر خطا شامل جزییات بیشتر (مثل متا ارورها) باشد
            if (
                err.response &&
                err.response.data &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            ) {
              this.errorMessage = err.response.data.response.meta.errors;
            }

            // نمایش پیام خطا
            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });

            // غیر فعال کردن لودینگ
            this.submitLoading = false;
            console.error("Error:", err);
          });
    },

    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
            "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data.data;
            this.buildings = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    getExperience() {
      const requestData = {
        method: "get",
        url: `/admin/experiences/${this.$route.params.id}`,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;

            this.experience = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    formatnumber(newValue) {
      const result = newValue
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    removeDiscount(index) {
      this.removeDiscountBtnIsClicked = true;
      this.ticketInput.prices_off.splice(index, 1);
      this.discounts = this.discounts - 1;
    },

    removeService(index) {
      this.removeServicesBtnIsClicked = true;
      this.ticketInput.special_services.splice(index, 1);
      this.services = this.services - 1;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>